import { type Area, AreaType } from '@/types/booliApi';

export function getAreaModeDescription(
  areaMode: NonNullable<AreaType | null>,
  areaParent: number | null,
  areaData: Area[],
  areaIds: number[],
) {
  if (!areaMode) {
    return 'Sverige';
  } else {
    switch (areaMode) {
      case AreaType.Municipality:
        if (areaParent) {
          const area = areaData.find((area) => areaParent === area.id)?.name;
          return `Kommuner i ${area}`;
        } else {
          return 'Kommuner i Sverige';
        }
      case AreaType.County:
        return 'Alla län';
      case AreaType.Country:
        return 'Sverige';
      case AreaType.SuburbAndLocality:
        if (areaParent) {
          const area = areaData.find((area) => areaParent === area.id)?.name;
          return `Stadsdelar i ${area}`;
        } else {
          return 'Stadsdelar i Sverige';
        }
      default:
        if (areaIds.length > 0) {
          const areas = areaIds.map((id) => areaData.find((area) => id === area.id)?.name);
          const areaStr = areas.filter(Boolean).join(' & ');
          return areaStr;
        } else {
          return 'Sverige';
        }
    }
  }
}
